export default __webpack_public_path__ + "static/media/Akzidenz-GroteskCondensed.f129290c.woff";